import { render, staticRenderFns } from "./main.vue?vue&type=template&id=70928a07&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=70928a07&prod&lang=scss&scoped=true"
import style1 from "./main.vue?vue&type=style&index=1&id=70928a07&prod&lang=scss"
import style2 from "./main.vue?vue&type=style&index=2&id=70928a07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70928a07",
  null
  
)

export default component.exports